import * as s from "./website-head-submenu-content.scss";
import {Network} from "../../../../../../../network/Network";
import {Resources} from "../../../../../../../resources/Resources";
import {WebsiteHeadSubmenuContentComponent} from "./WebsiteHeadSubmenuContentComponent";
import {
    isMobile
} from "../../../../../../../sedestral/framework/utilities/IsMobile";

export class WebsiteHeadSubmenuContentResourcesComponent extends WebsiteHeadSubmenuContentComponent {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteHeadSubmenuContent}">
                <div class="${s.column}">
                    <div class="${s.title}">
                        ${Resources.t("words.resources")}
                        <div class="${s.arrow}"></div>
                    </div>
                    <div class="${s.cases}">
                        <a itemprop="url" href="${Network.router.pages.getUrlWithPath('guide/seo-naturel')}">
                            <div class="${s.case}">
                                <div class="${s.capsuleContainer} ${s.grey}">
                                    <div class="${s.icon} ${s.guide}"></div>
                                </div>
                                <div class="${s.texts}">
                                    <p itemprop="name" class="${s.caseTitle}">
                                        ${Resources.t("words.seoGuides")}
                                    </p>
                                    <p class="${s.description}">
                                        ${Resources.t("words.seoGuidesDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <!--
                        <a itemprop="url" href="${Network.router.pages.getUrlWithPath('blog')}">
                            <div class="${s.case}">
                                <div class="${s.capsuleContainer} ${s.grey}">
                                    <div class="${s.icon} ${s.blog}"></div>
                                </div>
                                <div class="${s.texts}">
                                    <p itemprop="name" class="${s.caseTitle}">
                                        ${Resources.t("words.blog")}
                                    </p>
                                    <p class="${s.description}">
                                        ${Resources.t("words.blogDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        -->
                        <a itemprop="url" href="${Network.router.pages.getUrlWithPath('prestashop')}">
                            <div class="${s.case}">
                                <div class="${s.capsuleContainer} ${s.grey}">
                                    <div class="${s.icon} ${s.prestashop}"></div>
                                </div>
                                <div class="${s.texts}">
                                    <p itemprop="name" class="${s.caseTitle}">
                                        ${Resources.t("words.prestaBlogModule")}
                                    </p>
                                    <p class="${s.description}">
                                        ${Resources.t("words.prestaBlogDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="${s.column}">
                    <div class="${s.title}">
                        ${Resources.t("words.clientTestimonials")}
                        <div class="${s.arrow}"></div>
                    </div>
                    <div class="${s.cases}">
                        <a itemprop="url" href="${Network.router.pages.getUrlWithPath('testimonial/bet-thermique')}">
                            <div class="${s.case}">
                                <div class="${s.capsuleContainer} ${s.grey}">
                                    <div class="${s.icon} ${s.bet}"></div>
                                </div>
                                <div class="${s.texts}">
                                    <p itemprop="name" class="${s.caseTitle}">
                                        ${Resources.t("words.betThermique")}
                                    </p>
                                    <p class="${s.description}">
                                        ${Resources.t("words.betThermiqueDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                        <a itemprop="url" href="${Network.router.pages.getUrlWithPath('testimonial/rayssaguel')}">
                            <div class="${s.case}">
                                <div class="${s.capsuleContainer} ${s.grey}">
                                    <div class="${s.icon} ${s.rayssa}"></div>
                                </div>
                                <div class="${s.texts}">
                                    <p itemprop="name" class="${s.caseTitle}">
                                        ${Resources.t("words.rayssaguel")}
                                    </p>
                                    <p class="${s.description}">
                                        ${Resources.t("words.rayssaguelSeoDescription")}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        if (isMobile()) {
            this.els(s.column).forEach(value => {
                value.onClick(() => {
                    this.els(s.column).forEach(value => this.closeColumn(value));
                    this.openColumn(value);
                })
            });
        }

        super.commit();
    }

}